import { render, staticRenderFns } from "./SidebarMantenimientoGestor.vue?vue&type=template&id=28fcf3bf&scoped=true"
import script from "./SidebarMantenimientoGestor.vue?vue&type=script&lang=js"
export * from "./SidebarMantenimientoGestor.vue?vue&type=script&lang=js"
import style0 from "./SidebarMantenimientoGestor.vue?vue&type=style&index=0&id=28fcf3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fcf3bf",
  null
  
)

export default component.exports